"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _Table = require("../Table.styles");

var _util = require("../../../util");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.medium, ";font-size:", theme.fontSize.large, ";padding:", (0, _util.rem)(13), " ", (0, _util.rem)(24), ";background-color:", theme.color.monochrome.white, ";border-top-left-radius:", _Table.borderRadius, ";border-top-right-radius:", _Table.borderRadius, ";box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);border-bottom:1px solid ", theme.color.monochrome.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=Header.styles.js.map